
import { fetchTireuse } from '@/assets/scripts/api'
import PageData from '@/mixins/PageData'

export default {
  name: 'TireusePage',

  mixins: [PageData],

  async asyncData() {
    return { apiData: await fetchTireuse() }
  },
};
